import React from "react";
import { Layout, Spin, Row } from 'antd';


const { Content } = Layout;

export const Loader = () => {

    return (
        <Layout>
            <Content>
                <Row align="middle" justify="center" style={{height: '100vh'}}>
                    <Spin />
                </Row>
            </Content>
        </Layout>
    )
}